import basicScroll from 'basicscroll'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export default {
	init() {
		scrollReveals()
		parallax()
	},
	finalize() {
		// JavaScript to be fired on the blog page, after the init JS
	},
}

function scrollReveals() {
	let $newsItems = $('.sen-item')
	let news_tl = gsap.timeline({
		scrollTrigger: {
			trigger: '.main-content-wrap',
			start: 'top center+=300', // when the top of the trigger hits the center of the viewport
			// markers: true,
		},
	})
	$newsItems.each(function (i) {
		news_tl.fromTo(
			$(this)[0],
			{
				opacity: 0,
				y: 40,
			},
			{
				delay: i * 0.001,
				duration: 0.5,
				opacity: 1,
				y: 0,
			}
		)
	})
}

function parallax() {
	let scrollAnimations = []

	scrollAnimations.push(
		basicScroll.create({
			elem: $('.main-content-wrap .compass-svg')[0],
			from: 'top-bottom',
			to: 'bottom-top',
			direct: true,
			props: {
				'--nty':
					innerWidth > 600
						? {
								from: '-49.5%',
								to: '-59%',
						  }
						: {
								from: '-49.5%',
								to: '-59%',
						  },
			},
		})
	)

	if (scrollAnimations.length) {
		scrollAnimations.forEach((instance) => instance.start())
	}
}
